import { Button, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { memo } from "react";

import Trans from "@/components/Trans/Trans";

import { MAX_LOREBOOK_ENTRIES } from "../constants";

interface IEntriesCreateHeaderProps {
  onOpenCreateEntry: () => void;
  hasReachedEntryLimit: boolean;
  showNoEntriesError?: boolean;
  isUnderReview?: boolean;
  testID?: string;
}

const MAX_ENTRIES_LABEL_VALUES = { max: MAX_LOREBOOK_ENTRIES.toLocaleString() };

function EntriesCreateHeader({
  onOpenCreateEntry,
  hasReachedEntryLimit,
  showNoEntriesError = false,
  isUnderReview = false,
  testID = "EntriesCreateHeader",
}: IEntriesCreateHeaderProps) {
  return (
    <div className="flex flex-col gap-sm" data-testid={testID}>
      <Button
        variant={ButtonVariant.INVERSE}
        onClick={onOpenCreateEntry}
        disabled={isUnderReview}
        aria-disabled={isUnderReview}
        className={isUnderReview ? "opacity-50 cursor-not-allowed" : ""}
        data-testid="EntriesCreateHeader-AddEntryButton"
      >
        <Trans i18nKey="lorebook:form.button.addEntry" />
      </Button>
      {showNoEntriesError ? (
        <Text
          variant={TextVariants.LABEL_SMALL_REGULAR}
          className="text-red-9"
          role="alert"
          aria-live="polite"
          data-testid="EntriesCreateHeader-NoEntriesError"
        >
          <Trans
            i18nKey="lorebook:form.entriesTabSubmitError.title"
            defaults="Please add at least 5 entries before submitting your Lorebook for review."
          />
        </Text>
      ) : (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-11">
          {hasReachedEntryLimit ? (
            <Trans i18nKey="lorebook:entries.maxReached" values={MAX_ENTRIES_LABEL_VALUES} />
          ) : (
            <Trans i18nKey="lorebook:entries.helperWithMax" values={MAX_ENTRIES_LABEL_VALUES} />
          )}
        </Text>
      )}
    </div>
  );
}

export default memo(EntriesCreateHeader);
